<div class="modal-body">
    <rask-textarea label="Anteckning" class="col-12" [rows]="9" [maxlength]="2000" [ngModel]="$safeNavigationMigration(restriktion?.anteckning)"
        (ngModelChange)="UpdateRestriktionAnteckning(restriktion, $event)"></rask-textarea>
        <small class="senastandrad"><i>Senast ändrad: {{restriktion?.anteckningSenastAndradAv}} ({{senastAndradAnteckning}})</i></small>
    @if (restriktionKallor !== null && restriktionKallor?.length > 0) {
    <rask-header class="ovrigt-label" size="3">Övrig information</rask-header>
    <div class="row">
        <rask-list [data]="restriktionKallor">
            <rask-list-column header="Beteckning" field="beteckning"></rask-list-column>
            <rask-list-column header="Beskrivning" field="anteckning">
                <ng-template let-row="row">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <rask-text-expander [text]="row.anteckning" [rows]="4"></rask-text-expander>
                        </div>
                    </div>
                </ng-template>
            </rask-list-column>
            <rask-list-column header="Källa" field="kalla"></rask-list-column>
        </rask-list>
    </div>
    }
</div>
<div class="modal-footer">
    <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!canSave()">Spara</rask-button>
    <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
</div>